(function ($) {

  $.fn.addRequiredPackageProductToCart = function () {
    let btn = $(this);
    let cont = btn.closest('.required-packages-container');
    let productId = cont.attr('data-productid');
    let variantId = cont.attr('data-variantid');
    let lastItem = btn.attr('data-last-item');
    let qty = parseInt(cont.attr('data-required-quantity'));
    let form = $('form.ProductForm');
    let qty_val = parseInt(form.find('input[name="quantity"]').val());

    let valid = form.find('input[name="quantity"]').validateProductForm();
    if(!valid) {
      return;
    }

    if (cont.hasClass('tpl-package')) {
      window.location.href = btn.attr('href');
      return;
    } else if (window.location.href.indexOf("cart") > -1) {
      $('.Cart__Checkout').trigger('click');
      return;
    }

    if (qty_val < qty) {
      form.find('input[name="quantity"]').val(qty);
    }


    $.ajax({
      type: 'GET',
      url: '/cart.json',
      dataType: 'jsonp',
      success: function (response) {

        let items = response.items;

        let currentKey = null;
        let inCart = false;
        items.forEach(function (item) {
          if (item.product_id == productId) {
            inCart = true;
            currentKey = item.key;
          }
        });

        let data = form.serialize();
        let url = '/cart/add.js';

        let unserialized = unserialize(data);
        unserialized['properties[_required_package_item]'] = true;

        if (inCart) {
          url = '/cart/change.js';

          if (currentKey) data.id = currentKey;
          unserialized.id = currentKey;
        }
        data = jQuery.param(unserialized);

        jQuery.ajax({
          type: 'POST',
          url: url,
          data: data,
          dataType: 'json',
          success: function () {
            window.location.href = btn.attr('href');
          }
        });

      }
    });

  };

  $(document).on('click', '.add-kit-to-cart', function (e) {
    setCookie('required_package_initialized', $(this).attr('data-kitid'), 1);
  });

  $(document).on('click', '.add-required-package-product-to-cart', function (e) {
    e.preventDefault();
    $(this).addRequiredPackageProductToCart();
  });

  $(document).on('click', '.CartItem.package-item .CartItem__Remove', function (e) {
    e.preventDefault();

    $.get(window.Shopify.routes.root + 'cart.json', function(cart) {
        const updates = cart.items.map(item => {
          return item.properties?._required_package_item != null
            ? 0 
            : item.quantity; 
        }); 

        $.post(window.Shopify.routes.root + 'cart/update.js', { updates: updates }, function(updated) {
          eraseCookie('required_package_initialized');
          eraseCookie('required_package_finished');
          window.location.href = '/cart';
        }, 'json');
    }, 'json');
  });

  $(function () {
    const kits = $('.required-packages-container').data('kits') || []; 
    const handles = kits.map(kit => kit.products).flat().map(p => p.product.handle); 
    const isKitProduct = handles.filter(handle => window.location.href.indexOf(`/products/${handle}`) > -1).length > 0;


    if (getCookie('required_package_initialized') != null && getCookie('required_package_finished') == null && isKitProduct) {
      $('body').addClass('required-package-initialized');
      initRequiredPackage();
    }
  });

  function initRequiredPackage(redirect = false) {
    let cont = $('.required-packages-container');
    let kits = JSON.parse(cont.attr('data-kits'));
    let productId = parseInt(cont.attr('data-productid'));
    let packageId = parseInt(getCookie('required_package_initialized'));

    let kit = null;
    kits.forEach(function (_kit) {
      if (_kit.id == packageId) {
        kit = _kit;
      }
    });

    let products = kit.products;

    let currentIndex = null;
    for (let i = 0; i < products.length; i++) {
      if (products[i].product.id == productId) {
        currentIndex = i;
      }
    }

    $.ajax({
      type: 'GET',
      url: '/cart.json',
      dataType: 'jsonp',
      success: function (response) {

        let items = response.items;
        let prevItem = null;
        let nextItem = null;
        let currentItem = null;
        let currentCartItem = null;
        let total = products.length;

        let i = 0;
        let current = i;
        products.forEach(function (_product) {
          let inCart = false;
          items.forEach(function (item) {
            if (item.product_id == _product.product.id) {
              inCart = true;
              current++;
              if(item.product_id == productId) {
                currentCartItem = item;
              }
            }
          });
          if (!nextItem && !inCart && _product.product.id != productId) {
            nextItem = _product;
          } else if (_product.product.id == productId) {
            currentItem = _product;
          }
          i++;
        });

        if (currentIndex) {
          if (currentIndex > 0) prevItem = products[currentIndex - 1];
          currentItem = products[currentIndex];
          if ((currentIndex + 1) <= products.length) nextItem = products[currentIndex + 1];
        } else {
          prevItem = products[products.length - 1];
        }

        if (total == current) {
          setCookie('required_package_finished', true, 1);
        } else if (total > current) {
          eraseCookie('required_package_finished');
          if (window.location.href.indexOf("cart") > -1) {
            redirect = true
          }
        }

        if (nextItem) {
          cont.find('.add-required-package-product-to-cart')
            .attr('href', '/products/' + nextItem.product.handle)
            .attr('data-last-item', 'false');
        } else {
          cont.find('.add-required-package-product-to-cart')
            .attr('href', '/cart')
            .attr('data-last-item', 'true');
        }

        if (prevItem && currentIndex > 0) {
          cont.find('.required-package-back').attr('href', '/products/' + prevItem.product.handle);
          cont.find('.required-package-back').removeClass('hidden');
        }
        if (currentItem) {
          cont.attr('data-required-quantity', currentItem.quantity);
          $('.QuantitySelector__CurrentQuantity').val(currentItem.quantity);
          $('.QuantitySelector__CurrentQuantity').attr('min', currentItem.quantity);
          if(currentCartItem) {

            for(var prop in currentCartItem.properties) {
              if($('input[name="properties['+prop+']"]').length > 0) {
                $('input[name="properties['+prop+']"]').val(currentCartItem.properties[prop]);
              }
            }
          }
        }

        let progressContainer = $('.progress-container');
        progressContainer.find('.current').html(current);
        progressContainer.find('.total').html(total);
        progressContainer.find('.percentage .bg').css('width', (parseInt(current) / parseInt(total)) * 100 + '%');

        if (redirect) {
          if (nextItem) window.location.href = '/products/' + nextItem.product.handle
          else if (prevItem) window.location.href = '/products/' + prevItem.product.handle
        }
      }
    });
  }

  function unserialize(serializedData) {
    let urlParams = new URLSearchParams(serializedData); // get interface / iterator
    let unserializedData = {}; // prepare result object
    for (let [key, value] of urlParams) { // get pair > extract it to key/value
      unserializedData[key] = value;
    }

    return unserializedData;
  }
})(jQuery);